import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { EdDashboard, EdDashboardApi } from '../tokens/ed-dashboard.token';

/**
 * REST implementation of the E-D Dashboard API (PRD §3.1, EM-828).
 *
 *   GET /services/embedded/api/v1/ed/dashboard
 *
 * Read-only aggregate composed from the calling E-D's portfolio; scoped server-side (Rule 22).
 * REST-only (Rules 07/10). Bound to ED_DASHBOARD in mock-data.providers.ts.
 */
@Injectable({ providedIn: 'root' })
export class EdDashboardRestService implements EdDashboardApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/ed`;

  getDashboard(): Observable<EdDashboard> {
    return this.http.get<EdDashboard>(`${this.base}/dashboard`);
  }
}
